import { Input } from '../../../components/ui';

interface PhoneInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    required?: boolean;
    error?: string;
}

/**
 * PhoneInput component - Validates phone number (10 digits)
 */
export default function PhoneInput({
    label,
    value,
    onChange,
    placeholder = '9876543210',
    required = false,
    error,
}: PhoneInputProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Only allow digits
        const cleaned = e.target.value.replace(/\D/g, '');
        // Limit to 10 digits
        const limited = cleaned.slice(0, 10);
        onChange(limited);
    };

    const isValid = value.length === 10;
    const showValidation = value.length > 0;

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-[#1e293b]">
                {label}
                {required && <span className="text-[#ef4444] ml-1">*</span>}
            </label>
            <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748b] font-medium">
                    +91
                </div>
                <Input
                    type="tel"
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className={`pl-14 ${
                        showValidation
                            ? isValid
                                ? 'border-[#10b981] focus:ring-[#10b981]'
                                : 'border-[#ef4444] focus:ring-[#ef4444]'
                            : ''
                    }`}
                />
                {showValidation && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                        {isValid ? (
                            <svg
                                className="w-5 h-5 text-[#10b981]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        ) : (
                            <svg
                                className="w-5 h-5 text-[#ef4444]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        )}
                    </div>
                )}
            </div>
            {error && <p className="text-xs text-[#ef4444]">{error}</p>}
            {!error && showValidation && !isValid && (
                <p className="text-xs text-[#ef4444]">Phone number must be exactly 10 digits</p>
            )}
            {!error && showValidation && isValid && (
                <p className="text-xs text-[#10b981]">Valid phone number</p>
            )}
        </div>
    );
}
